export const VERSION = {
  PROD: 'V. 3.14.0',
  QA: 'V. 5.25.3 (QA)',
}
